<template>
  <v-col cols="12" sm="6" lg="4" class="d-flex">
    <v-card :color="dark ? 'primary' : 'white'" :to="link" class="align-center" style="flex: 1">
      <v-img v-if="image" :src="image" aspect-ratio="2"></v-img>
      <v-card-text>
        <h4 :class="textClass" v-if="date && typeof date === 'string'" v-html="formatDate(date)"></h4>
        <h4 :class="textClass" v-else-if="date" v-html="formatDate(date[0], 'X')"></h4>
        <h3
          class="title font-weight-light"
          v-html="title"
          :class="textClass"
        ></h3>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import { formatDate } from '@/helpers.js'

export default {
  name: 'Card',
  props: {
    title: String,
    link: [String, Object],
    image: {
      type: [String, Boolean],
      default: false
    },
    date: {
      type: [String, Number, Boolean, Array],
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  methods: { formatDate },
  computed: {
    textClass () {
      return this.dark ? 'white--text' : 'primary--text'
    }
  }
}
</script>
